import { ApiService } from "../apiService";

export class TrackerRelationshipsService extends ApiService {
    constructor() {
        super();
        this.path = '/TrackerRelationships';
    }

    /** 
     * Function to get TrackerRelationshipViewModel
     * from controller to Kanban View.
    */
    getKanbanView(typeOperation) {
        return this.get(this.path + '/kanban/' + typeOperation);
    }

    getGridView() {
        return this.get(this.path + '/grid');
    }

    getReportView() {
        return this.get(this.path + '/report');
    }

    getAlarms(trackerRelationShipId) {
        return this.get(this.path + '/' + trackerRelationShipId + '/alarms');
    }
    /** 
    * Function to get TrackerRelationshipViewModel
    * from controller to temperature chart.
   */
    getTemperatureDetails(trackerRelationShipId, filters) {
        return this.get(this.path + '/' + trackerRelationShipId + '/sensors/details?filters=' + filters);
    }

    getDetailsCard(trackerRelationShipId, filters) {
        return this.get(this.path + '/' + trackerRelationShipId + '/sensorsFarm/details?filters=' + filters);
    }

    /** 
    * Function to get TrackerRelationshipViewModel
    * from controller to print lat long on map.
   */
    getLatLong(trackerRelationShipId) {
        return this.get(this.path + '/' + trackerRelationShipId + '/latlong/details');
    }


    /** 
     * Function to get TrackerRelationshipViewModel
     * from controller to vehicle details.
    */
    getVehicleDetails(trackerRelationShipId) {
        return this.get(this.path + '/' + trackerRelationShipId + '/details');
    }

    /** 
     * Function to get TrackerRelationshipViewModel
     * from controller when vehicle is in origin.
    */
    getInOriginInformation() {
        return this.get(this.path + '/inOrigin');
    }

    getCardsView(typeOperation) {

        return this.get(this.path + '/cards/' + typeOperation);
    }
    /** 
     * Function to get TrackerRelationshipViewModel
     * from controller when vehicle is in route.
     * @handleSuccess: function be called on success
    */
    getInRouteInformation() {
        return this.get(this.path + '/inRoute');
    }

    /** 
     * Function to get TrackerRelationshipViewModel
     * from controller when the route is finished
    */
    getFinishedRouteInformation() {
        return this.get(this.path + '/finishedRoute');
    }

    /**
     * Get the relationshipInfo using vehicle Id
     * @param {UUID} vehicleId 
     */
    getTrackerRelationship(vehicleId) {
        return this.get(this.path + '/trackerRelationship/' + vehicleId);
    }

    /**
     * Link Tracker with company and vehicle.
     * @param {*} trackerRelationship 
     * @returns 
     */
    postTrackerRelationship(trackerRelationship) {
        return this.post(this.path + '/link', trackerRelationship);
    }

    /**
     * Unlink Tracker 
     * @param {*} trackerId 
     */
    postUnlinkTrackerRelationship(trackerId) {
        return this.get(this.path + "/unlink/" + trackerId);
    }

    getOtaView() {
        return this.get(this.path + "/trackersRelationShipOTA/");
    }
}